<!-- eslint-disable max-len -->
<ng-template #rewaaLogo>
  <div class="max-auto flex justify-content-center">
    <svg
      *ngIf="isNewLogo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 255.12 141.73"
      width="120"
      height="67"
    >
      <g>
        <path
          style="fill: #00a4a6"
          d="M88.27,43.4h-3.8c-.58,0-1.05.47-1.05,1.05v34.43c0,.41.33.73.73.73h4.44c.41,0,.73-.33.73-.73v-34.43c0-.58-.47-1.05-1.05-1.05Z"
        />
        <path
          style="fill: #00a4a6"
          d="M158.58,90.43l-4.85,1.96h0s-5.67,2.3-5.67,2.3c-.44.18-.74.6-.76,1.07l-.15,2.07c-.03.57.54.97,1.07.76l6.89-2.79h0l3.62-1.47c.44-.18.74-.6.76-1.07l.15-2.07c.03-.57-.54-.97-1.07-.76Z"
        />
        <path
          style="fill: #00a4a6"
          d="M158.74,51.48h-4.06c-.5,0-.91.41-.91.91v25.08c0,5.56-.95,6.67-8.53,6.67-.23,0-4.74,0-5.19,0-.05,0-.11-.01-.16-.01h-1.68c-.24,0-.47,0-.66,0-.04,0-.07,0-.11,0h-1.89c-.48,0-.91.28-1.11.71l-2.05,4.43c-.24.51.14,1.1.7,1.1h5.78s.02,0,.03,0c.98,0,2.2,0,3.33,0,.23,0,.4,0,.48,0h0c1.56,0,2.84,0,2.92,0,9.65,0,14.02-2.74,14.02-12.74v-25.24c0-.5-.41-.91-.91-.91Z"
        />
        <path
          style="fill: #00a4a6"
          d="M128.45,51.48h-20.51c-9.39,0-12.38,3.87-12.7,12.34,0,.02,0,3.25,0,3.39,0,.02,0,.04,0,.06.33,8.47,3.31,12.34,12.7,12.34h7.33c.24,0,.47,0,.66,0,.04,0,.07,0,.11,0h1.89c.48,0,.91-.28,1.11-.71l2.05-4.43c.24-.51-.14-1.1-.7-1.1h-5,0s-7.29,0-7.29,0c-4.97,0-6.38-.76-6.63-6.32-.01-.32-.01-3.42,0-3.74.25-5.56,1.66-6.32,6.63-6.32h15.28v20.5c0,5.56-.95,6.65-8.53,6.65-.23,0-8.5,0-8.95,0-.05,0-.11,0-.16,0h-1.68c-.24,0-.47,0-.66,0-.04,0-.07,0-.11,0h-1.89c-.48,0-.91.28-1.11.71l-2.05,4.43c-.24.51.14,1.1.7,1.1h5.78c.05,0,.1,0,.15-.01.86,0,10.08.01,10.46.01,9.65,0,14.02-2.74,14.02-12.74v-25.24c0-.5-.41-.91-.91-.91Z"
        />
        <path
          style="fill: #00a4a6"
          d="M76.73,73.38h-9.17s-.07,0-.11,0h-.75s-7.29,0-7.29,0c-4.97,0-6.38-.76-6.63-6.32-.01-.32-.01-3.01,0-3.33v-.41c.25-5.56,1.66-5.91,6.63-5.91h12.69s4.33,0,4.33,0c.58,0,1.05-.47,1.05-1.05v-3.8c0-.58-.47-1.05-1.05-1.05h-17.19c-9.39,0-12.38,3.87-12.7,12.34,0,.02,0,3.25,0,3.39,0,.02,0,.04,0,.06.09,2.4.4,4.42,1,6.1h-1.11c-.48,0-.91.28-1.11.71l-2.05,4.44c-.24.51.14,1.1.7,1.1h21.01s0,0,0,0h9.28c.48,0,.91-.28,1.11-.71l2.05-4.43c.24-.51-.14-1.1-.7-1.1Z"
        />
      </g>
      <path
        style="fill: #00a4a6"
        d="M207.67,47.27c-2.67-2.67-6.21-4.17-9.98-4.23-.08,0-.15,0-.23,0h-14.79s-.04,0-.06,0c-4.91.03-8.9,4.04-8.9,8.96,0,.82.11,1.62.32,2.37,0,.02,0,.03.01.05,0,.02.01.05.02.07l10.79,37.61s0,0,0,0c1.04,3.79,4.52,6.58,8.64,6.58,1.36,0,2.65-.31,3.81-.85.94-.44,1.79-1.05,2.52-1.77,1.08-1.08,1.89-2.44,2.31-3.96h0l7.69-25.55,1.44-4.79.05-.16s0-.01,0-.02c.39-1.31.59-2.69.59-4.09,0-3.86-1.5-7.49-4.23-10.21ZM206.05,59.99h0c-.07.25-.15.48-.24.71l-3.52,10.41-3.79,11.21-2.75,8.12h0s-.03.09-.04.13c-.34.91-1.21,1.55-2.23,1.55-.61,0-1.17-.23-1.59-.62-.31-.28-.55-.65-.68-1.06h0l-.25-.86-2.14-7.48-6.06-21.13-2.35-8.2c-.02-.07-.04-.14-.06-.21h0c-.04-.18-.06-.36-.06-.55,0-1.31,1.07-2.37,2.37-2.37l2.81-.21,5.63-.43,5.76-.44h0c.2,0,.4-.01.6-.01,4.94,0,8.96,4.02,8.96,8.96,0,.87-.12,1.71-.36,2.5Z"
      />
    </svg>
    <svg
      *ngIf="!isNewLogo"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_29_955)">
        <path
          d="M24.1216 2.00145H11.2734C10.9199 1.99746 10.5704 2.07632 10.2533 2.23163C9.93627 2.38694 9.66059 2.61432 9.44866 2.8953C9.23673 3.17628 9.09453 3.50293 9.03362 3.84873C8.9727 4.19453 8.99479 4.54972 9.09808 4.88545L20.0611 39.5575C20.2108 40.0132 20.5018 40.4102 20.8925 40.6918C21.2832 40.9733 21.7536 41.1249 22.2364 41.1249C22.7191 41.1249 23.1895 40.9733 23.5802 40.6918C23.9709 40.4102 24.262 40.0132 24.4117 39.5575L32.6938 13.3575C33.0982 12.035 33.1831 10.6366 32.9419 9.27549C32.7006 7.91438 32.1399 6.62883 31.3051 5.52296C30.4703 4.4171 29.385 3.52201 28.137 2.91021C26.889 2.2984 25.5134 1.98708 24.1216 2.00145Z"
          fill="#78CAD5"
        />
        <path
          opacity="0.9"
          d="M30.2648 6.36148H16.8163C16.4977 6.35826 16.1827 6.42958 15.897 6.56965C15.6112 6.70973 15.3627 6.91462 15.1715 7.16777C14.9803 7.42092 14.8518 7.7152 14.7964 8.02681C14.741 8.33843 14.7602 8.65861 14.8525 8.96148L26.1157 44.5815C26.2502 44.9935 26.5127 45.3525 26.8655 45.6072C27.2183 45.8619 27.6433 45.999 28.0794 45.999C28.5156 45.999 28.9406 45.8619 29.2934 45.6072C29.6462 45.3525 29.9087 44.9935 30.0432 44.5815L38.6255 17.4395C39.021 16.1495 39.1047 14.7852 38.8698 13.4571C38.6349 12.129 38.0882 10.8746 37.2738 9.79554C36.4595 8.71651 35.4004 7.84327 34.1827 7.24662C32.9649 6.64997 31.6227 6.34673 30.2648 6.36148Z"
          fill="#00A5A3"
        />
      </g>
      <defs>
        <clipPath id="clip0_29_955">
          <rect
            width="30"
            height="43.998"
            fill="white"
            transform="translate(9 2.00098)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</ng-template>
<div id="entire-thing">
  <div
    class="rw-main-content"
    [ngClass]="{ 'top-margin': !isBulkOperation }"
  ></div>

  <div id="invoice-page"></div>

  <div class="hide">
    <!-- Header - Start -->
    <!-- <header
    class="grid pb-3"
    id="header"
  ></header> -->

    <!-- Invoice & Buyer Info - Start -->
    <!-- <div
    class="grid"
    id="customer-info"
  >
    <div class="col-3">
      <div class="font-medium">Bill to</div>
      <div class="font-medium text-neutral-60 mb-1">العميل</div>
      <div>مؤسسة عبدالرحمن هلال للمقاولات والترقيع شركة شخص واحد</div>
      <div>
        3575 Al Feidh, Irqah Unit 123456789011 No Kingdom of Saudi Arabia
      </div>
    </div>
    <div class="col-3">
      <div class="flex flex-column gap-2">
        <div>
          <div class="font-medium">Buyer Tax Number</div>
          <div class="font-medium text-neutral-60 mb-1">
            رقم السجل الضريبي للعميل
          </div>
          <div>264867547786453</div>
        </div>
        <div>
          <div class="font-medium">Buyer ID: CR</div>
          <div class="font-medium text-neutral-60 mb-1">
            معرّف العميل: سجل تجاري
          </div>
          <div>1234567890</div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="flex flex-column gap-2">
        <div>
          <div class="font-medium">Invoice Number</div>
          <div class="font-medium text-neutral-60 mb-1">رقم الفاتورة</div>
          <div>{{ invoice.id }}</div>
        </div>
        <div>
          <div class="font-medium">Invoice Issue Date</div>
          <div class="font-medium text-neutral-60 mb-1">
            تاريخ إصدار الفاتورة
          </div>
          <div>23 Dec 2024, 07:35:59 AM</div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="flex flex-column gap-2 text-right">
        <div>
          <div class="font-medium">Reference No.</div>
          <div class="font-medium text-neutral-60 mb-1">رقم مرجعي</div>
          <div>11223344</div>
        </div>
        <div>
          <div class="font-medium">Supply Date</div>
          <div class="font-medium text-neutral-60 mb-1">تاريخ التسليم</div>
          <div>23 Dec 2024</div>
        </div>
      </div>
    </div>
  </div> -->

    <!-- Price Highlight - Start -->
    <div class="text-right pt-2 border-top-1 border-neutral-20">
      <div class="font-medium">Total Due</div>
      <div class="font-medium text-neutral-60">إجمالي المستحق</div>
      <div class="flex gap-1 align-items-center justify-content-end">
        <div class="line-height-1">
          <div class="rw__fs-9">SAR</div>
          <div class="rw__fs-11 text-neutral-60">ر.س</div>
        </div>
        <div class="rw__fs-5">2300.00</div>
      </div>
    </div>

    <!-- Invoice Item Line Table - Start-->
    <div class="pb-2 pt-3">
      <table class="print-table print-border-table print-item-table">
        <thead>
          <tr>
            <th class="text-left">
              <div class="font-medium text-neutral-60">#</div>
            </th>
            <th>
              ¡
              <div class="font-medium">Item / Description</div>
              <div class="font-medium text-neutral-60">الوصف / المنتج</div>
            </th>
            <th>
              <div class="font-medium">Price</div>
              <div class="font-medium text-neutral-60">سعر الوحدة</div>
            </th>
            <th>
              <div class="font-medium">Quantity</div>
              <div class="font-medium text-neutral-60">الكمية</div>
            </th>
            <th>
              <div class="font-medium">Discount</div>
              <div class="font-medium text-neutral-60">خصم</div>
            </th>
            <th>
              <div class="font-medium">Taxable Amount</div>
              <div class="font-medium text-neutral-60">
                المبلغ الخاضع للضريبة
              </div>
            </th>
            <th>
              <div class="font-medium">VAT</div>
              <div class="font-medium text-neutral-60">القيمة المضافة</div>
            </th>
            <th>
              <div class="font-medium">Amount</div>
              <div class="font-medium text-neutral-60">المجموع</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">
              <div class="font-medium text-neutral-60">1</div>
            </td>
            <td class="text-neutral-60">
              <div class="font-semibold">
                <div>Basic Plan (1 year)</div>
                <div>اشتراك باقة أساسية (سنة)</div>
              </div>
              <div>1 Jan 2023-31 Dec 2024</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>x3</div>
            </td>
            <td>
              <div>-4000</div>
              <div class="text-neutral-60">60%</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>300</div>
              <div class="text-neutral-60">15%</div>
            </td>
            <td>
              <div>2300</div>
            </td>
          </tr>
          <tr>
            <td class="text-left">
              <div class="font-medium text-neutral-60">1</div>
            </td>
            <td class="text-neutral-60">
              <div class="font-semibold">
                <div>Basic Plan (1 year)</div>
                <div>اشتراك باقة أساسية (سنة)</div>
              </div>
              <div>1 Jan 2023-31 Dec 2024</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>x3</div>
            </td>
            <td>
              <div>-4000</div>
              <div class="text-neutral-60">60%</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>300</div>
              <div class="text-neutral-60">15%</div>
            </td>
            <td>
              <div>2300</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Notes & Calculation Summary - Start -->
    <div class="grid">
      <div class="col-6">
        <div class="font-medium">Notes</div>
        <div class="font-medium text-neutral-60 mb-1">ملاحظات</div>
        <div>-</div>
      </div>
      <div class="col-6">
        <table class="print-table print-item-table">
          <tbody>
            <tr>
              <td>
                <div class="font-medium">Subtotal</div>
                <div class="font-medium text-neutral-60">
                  الإجمالي غير شامل الضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>6000</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total Discount</div>
                <div class="font-medium text-neutral-60">إجمالي الخصم</div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>-4000</div>
                <div class="text-neutral-60">60%</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total Taxable Amount</div>
                <div class="font-medium text-neutral-60">
                  إجمالي المبلغ الخاضع للضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>2000</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total VAT</div>
                <div class="font-medium text-neutral-60">
                  إجمالي ضريبة القيمة المضافة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>300</div>
                <div class="text-neutral-60">15%</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total</div>
                <div class="font-medium text-neutral-60">
                  الإجمالي شامل الضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div class="font-medium">2300</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9">
          <img
            src="/assets/images/invoice-pdf-qr.svg"
            alt=""
          />
          <div class="mt-2">
            This QR code is encoded as per ZATCA's invoicing requirements
          </div>
          <div>
            رمز الإستجابة السريعة مشفّر بحسب متطلبات هيئة الزكاة والضريبة
            والجمارك للفوترة الإلكترونية
          </div>
        </div>
        <div class="col-3">
          <div class="text-right">
            Page 1 of {{ isNewTC ? (info.taxInvoicePages + 4) : (info.taxInvoicePages + 2) }}
            @if (zatcaCompleted) {
              - {{ invoice.id }}
            }
          </div>
        </div>
      </div>
    </footer>
  </div>
  <!-- Invoice Page - End -->

  <!-- <div class="py-6"></div> -->

  <!-- Bank Transfer Information - Start -->
  <div
    class="print-wrapper page-break body"
    id="bank-transfer"
    [ngClass]="{ 'pt-6 html2pdf__page-break': isBulkOperation }"
    *ngIf="!isCreditNote"
  >
    @if (
      !zatcaCompleted && invoice?.zatcaStatus !== zatcaStatusConstant.PreZatca
    ) {
      <div class="watermark">
        <div>DRAFT INVOICE</div>
        <div>فاتـــــــــــــــــــــورة مسودّة</div>
      </div>
    }
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        @if (this.invoice?.invoice_type === 'B2C') {
          <div class="fs-22 font-semibold">Simplified Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">
            فاتوره ضريبية مبسطه
          </div>
        } @else {
          <div class="fs-22 font-semibold">Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">فاتورة ضريبية</div>
        }
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>
    <!-- Header - End -->

    <!-- Page Title - Start -->
    <div
      class="flex justify-content-between rw__fs-11 font-bold pb-3 border-neutral-20 border-bottom-1"
    >
      <div>Bank Transfer Information</div>
      <div>معلومات الحوالات البنكية</div>
    </div>
    <!-- Page Title - End -->

    <!-- Beneficiary Details - Start -->
    <div class="py-3">
      <div class="flex justify-content-between font-medium">
        <div>Beneficiary Name</div>
        <div>إسم المستفيد</div>
      </div>
      <div class="flex justify-content-between mt-1">
        <div>Rewaa Technology Limited Liability Company</div>
        <div>شركة رواء لتقنية المعلومات المحدودة</div>
      </div>
    </div>
    <!-- Beneficiary Details - End -->

    <!-- Bank Details - Start -->
    <div>
      <table class="print-table print-border-table bank-table">
        <thead>
          <tr>
            <th class="text-left"><div>Bank</div></th>
            <th>
              <div class="flex justify-content-between">
                <div>IBAN</div>
                <div>آيبان</div>
              </div>
            </th>
            <th>
              <div>البنك</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left"><div>Al Rajhi Bank</div></td>
            <td>
              <div>SA38 8000 0504 6080 1025 5470</div>
            </td>
            <td>
              <div>مصرف الراجحي</div>
            </td>
          </tr>
          <tr>
            <td class="text-left"><div>Riyad Bank</div></td>
            <td>
              <div>SA74 2000 0002 4116 3936 9940</div>
            </td>
            <td>
              <div>بنك الرياض</div>
            </td>
          </tr>
          <tr>
            <td class="text-left"><div>Saudi National Bank (SNB)</div></td>
            <td>
              <div>SA37 1000 0019 5000 0006 6907</div>
            </td>
            <td>
              <div>البنك الأهلي السعودي</div>
            </td>
          </tr>
          <tr>
            <td class="text-left"><div>SAIB Bank</div></td>
            <td>
              <div>SA85 6500 0000 1016 9293 9001</div>
            </td>
            <td>
              <div>البنك السعودي للإستثمار</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Bank Details - End -->

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9"></div>
        <div class="col-3">
          <div class="text-right">
            @if (isNewTC) {
              Page {{ info.taxInvoicePages + 1 }} of
              {{ info.taxInvoicePages + 4 }} -
            } @else {
              Page {{ info.taxInvoicePages + 1 }} of
              {{ info.taxInvoicePages + 2 }} -
            }
            {{ getInvoiceId }}
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer - End -->
  </div>
  <!-- Bank Transfer Information - End -->

  <!-- <div class="py-6"></div> -->

  <!-- Terms & Conditions - Start -->
  <div
    class="print-wrapper page-break body"
    id="T&C"
    [ngClass]="{ 'pt-6 html2pdf__page-break': isBulkOperation }"
    *ngIf="!isCreditNote"
  >
    @if (
      !zatcaCompleted && invoice?.zatcaStatus !== zatcaStatusConstant.PreZatca
    ) {
      <div class="watermark">
        <div>DRAFT INVOICE</div>
        <div>فاتـــــــــــــــــــــورة مسودّة</div>
      </div>
    }
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        @if (this.invoice?.invoice_type === 'B2C') {
          <div class="fs-22 font-semibold">Simplified Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">
            فاتوره ضريبية مبسطه
          </div>
        } @else {
          <div class="fs-22 font-semibold">Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">فاتورة ضريبية</div>
        }
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>
    <!-- Header - End -->

    <!-- Page Title - Start -->
    <div class="grid pb-2 border-neutral-20 border-bottom-1 align-items-end">
      <div class="col-5">
        <div class="rw__fs-11 font-bold">
          Terms &amp; Conditions, and Privacy Policy
        </div>
        <div class="text-neutral-60">
          Scan QR to go through all of the terms &amp; conditions
        </div>
      </div>
      <div class="flex justify-content-center mx-auto">
        <img
          width="90"
          height="90"
          [src]="termsAndCondition.qrCode"
          alt="terms and condition qr code"
        />
      </div>
      <div class="col-5 text-right">
        <div class="rw__fs-11 font-bold">الشروط والأحكام وسياسة الخصوصية</div>
        <div class="text-neutral-60">
          قم بمسح الرمز للإطلاع على جميع الشروط والأحكام
        </div>
      </div>
    </div>
    <!-- Page Title - End -->

    <!-- Terms Points - Start -->
    <div
      class="pt-2"
      *ngIf="!isNewTC"
    >
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Key Terms and Conditions</div>
          <div>
            The Terms and Conditions constitute a legally binding agreement
            between the customer and Rewaa for Information Technology. By using,
            subscribing to, or purchasing our services or products, you
            acknowledge your acceptance of our Terms & Conditions, and all
            policies published on our website, including the Privacy Policy. If
            you do not agree with these terms or any other Rewaa policies, you
            may submit a request for a refund of your subscription fee during
            the trial period (14 calendar days from the invoice date).
            Continuing to use Rewaa's services or products after the trial
            period is considered an explicit acceptance of these Terms and
            Conditions. Some of these terms include, but are not limited to:
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">أبرز الشروط والأحكام</div>
          <div class="rtl">
            الشروط والأحكام تمثل ملزمة قانونياً بين العميل وشركة رِواء التقنية
            لتقنية المعلومات. استخدامك لخدماتنا أو منتجاتنا أو الاشتراك فيها هو
            إقرار بقبولك هذه الشروط وكافة السياسات المنشورة على موقعنا، بما في
            ذلك سياسة الخصوصية. نوصيكم بمراجعتها للتأكد من أنها تتوافق مع
            توقعاتكم، يمكنكم الاطلاع عليها من خلال رمز الاستجابة السريع المرفق
            أو موقعنا الرسمي. في حال عدم موافقتكم على أي من الشروط أو السياسات،
            يمكنكم رفع طلب إرجاع لمبلغ الاشتراك خلال فترة التجربة (14 يومًا
            تقويميا من تاريخ فاتورة الشراء). استمراركم في استخدام خدمات أو
            منتجات رواء بعد انتهاء فترة التجربة يُعد موافقة صريحة وقبولًا ضمنيًا
            لهذه الشروط والأحكام. ونورد بعضها هنا على سبيل المثال لا الحصر:
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Software Operation Requirements</div>
          <div>
            The customer must ensure a suitable environment for operating the
            software, including providing the necessary hardware and high-speed
            internet. Click here for more details.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">متطلبات تشغيل الخدمة</div>
          <div class="rtl">
            يجب على العميل تأمين البيئة المناسبة لتشغيل البرنامج، بما في ذلك
            توفير الأجهزة اللازمة والإنترنت عالي السرعة. لمزيد من التفاصيل، يرجى
            الضغط على هذا الرابط.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Subscription Start Date</div>
          <div>
            The subscription begins from the date of the purchase invoice
            regardless of the date the hardware or/and any other devices are
            received. The subscription continues according to the package
            selected, and Rewaa is not liable for any delay caused by the
            customer in operating their business or operations.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">تاريخ بدء الاشتراك</div>
          <div class="rtl">
            يبدأ تاريخ الاشتراك اعتباراً من تاريخ إصدار فاتورة شراء، بغض النظر
            عن تاريخ استلام الأجهزة أو البدء بتجربة منصة رواء. ويستمر الاشتراك
            وفقًا للباقة التي تم الاشتراك بها، ولا تتحمل شركة رواء أي مسؤولية في
            حال تأخر العميل في تشغيل تجارته أو عملياته.
          </div>
        </div>
      </div>
      ر:
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Device Warranty</div>
          <div>
            Rewaa devices are covered by a two-year (2) warranty from the date
            of the purchase invoice.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">ضمان الأجهزة</div>
          <div class="rtl">
            ضمان أجهزة رِواء لمدة سنتين (2) من تاريخ فاتورة الشراء، ويشمل إصلاح
            أو استبدال الجهاز المتضرر بسبب العيوب التصنيعية بدون تكاليف إضافية.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Refund Policy</div>
          <div>
            Rewaa is committed to refunding any amounts paid for products or
            services within the 14-calendar-day trial period from the date of
            the purchase invoice. The refund request will be processed and the
            amount refunded within 30 calendar days from the date of approval of
            the return request or receipt of the devices with their accessories,
            including packaging. All 'Monsha'at' packages or customers
            benefiting from the 'Monsha'at' offer are excluded from the refund
            policy and they are not entitled to request a refund or
            reimbursement of the paid amounts
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">سياسة الإرجاع</div>
          <div class="rtl">
            تلتزم شركة رِواء التقنية باسترداد أي مبلغ مدفوع على المنتجات أو
            الخدمات خلال فترة التجربة التي تمتد لـ 14 يوما تقويميا من تاريخ
            إصدار فاتورة الشراء. يتم معالجة طلب الإرجاع وإعادة المبلغ خلال 30
            يوما تقويميا من تاريخ اعتماد طلب الإرجاع أو استلام الأجهزة بكامل
            ملحقاتها، بما في ذلك الكرتون. ويُستثنى من سياسة الإرجاع جميع باقات
            “منشآت” أو العملاء المستفيدين من عرض “منشآت”، حيث لا يحق لهم طلب
            الإرجاع أو استرداد المبالغ المدفوعة.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Technical Support</div>
          <div>
            Rewaa provides remote technical support exclusively through official
            communication channels, without any obligation to perform on-site
            visits or operational tasks on behalf of the client. Technical
            support is available 24/7 to assist you via live chat within the
            platform, toll-free number: 8001244020, or email:
            info&#64;rewaatech.com
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">الدعم الفني</div>
          <div class="rtl">
            تقدم شركة رِواء الدعم الفني عن بُعد عبر قنوات التواصل الرسمية فقط،
            دون أي التزام بإجراء الزيارات الميدانية أو الأعمال التشغيلية نيابة
            عن العميل. الدعم الفني متاح لمساعدتك على مدار الساعة 24/7 عبر
            الدردشة الحية من داخل المنصة أو الرقم الموحد 8001244020 أو البريد
            الإلكتروني info&#64;rewaatech.com
          </div>
        </div>
      </div>
    </div>
    <!-- Terms Points - End -->

    <!-- New Terms Points - Start -->
    <div
      class="pt-2"
      *ngIf="isNewTC"
    >
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">Key Terms and Conditions</div>
          <div>
            These provisions constitute a legally binding agreement (the
            "Provisions") between you ("Client") and Rewaa Technology LLC (the
            "Company"). Your use of services or acceptance constitutes agreement
            to all terms and policies and any amendments thereto. The following
            summarizes key terms, with complete Terms and Conditions available
            on the Company's website:
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">أبرز الشروط والأحكام</div>
          <div class="rtl">
            هذه البنود اتفاقية قانونية ملزمة بينك ("العميل") وشركة رِواء التقنية
            لتقنية المعلومات ذ.م.م ("الشركة"). يمكنك مراجعة الشروط والأحكام
            وكافة السياسات والتعديلات التي تنطبق عليها من وقت لآخر من خلال زيارة
            موقع الشركة. يمثل استخدامك للخدمات أو موافقتك على هذه الاتفاقية
            قبولاً ملزماً بكافة الشروط والأحكام والسياسات المطبقة أو تعديلات
            تطرأ عليها. تعد البنود الواردة هنا جزءً منها لغرض الإشارة لأبرزها
            على سبيل المثال لا الحصر:
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">1. Subscription Commencement Date</div>
          <div>
            Subscriptions begin on invoice date ("Subscription Commencement
            Date") with automatic annual renewal, unless package terms specify
            otherwise. Additional Services subscribed during the term will align
            with the primary subscription's expiration date and auto-renew,
            unless Client provides written notice to the contrary.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١. تاريخ بدء الاشتراك</div>
          <div class="rtl">
            يبدأ سريان الاشتراك اعتباراً من تاريخ إصدار الفاتورة ("تاريخ بدء
            الاشتراك")، ويتجدد سنوياً ما لم يكن هناك فترة محددة ومشمولة للباقة
            المختارة. وإذا اشترك العميل في أي من الخدمات الإضافية التي تقدمها
            الشركة مباشرة خلال مدة الاشتراك ("الخدمات الإضافية") تُستحق الرسوم
            الإضافية الخاصة بتلك الخدمات حتى تاريخ انتهاء الاشتراك الرئيسي
            وتتجدد تلقائياً من تاريخ بدء الاشتراك للمدة اللاحقة ما لم يبدِ
            العميل صراحة وكتابة خلاف ذلك.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">2. Service Benefits</div>
          <div>
            Service benefits commence automatically on the Subscription
            Commencement Date. Non-activation or non-use by Client shall not
            affect the subscription term for any services.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٢. مزايا الخدمة</div>
          <div class="rtl">
            يُعد العميل قد استفاد من الخدمة من تاريخ بدء الاشتراك تلقائياً ويعد
            ذلك تسليماً وتخلية بين العميل والخدمة، وذلك بغض النظر عن استخدامه
            الفعلي للخدمة الرئيسية أو الإضافية.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">
            3. Subscription Fees Subject to Change
          </div>
          <div>
            Subscription fees for the primary service and any additional
            services are subject to change, and the Company is not obligated to
            ensure that renewal fees are identical to those applicable during
            the initial subscription term.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٣. رسوم الاشتراك قابلة للتغيير</div>
          <div class="rtl">
            تخضع رسوم الاشتراك للخدمة الرئيسية وأي من الخدمات الإضافية للتغيير،
            ولا تلتزم الشركة بضمان أن تكون رسوم التجديد مماثلة لقيمة الاشتراك
            الساري وقت الاشتراك الأول.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">
            4. Special Terms and Promotional Offers
          </div>
          <div>
            The special terms associated with promotional offers or packages
            ("Special Terms") are limited exclusively to their explicitly
            specified duration and do not renew automatically. Promotional
            prices or discounts, for example, are confined to their specified
            period and expire accordingly. The validity of the Special Terms is
            contingent upon completing the full subscription period.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٤. الشروط الخاصة والعروض الترويجية</div>
          <div class="rtl">
            تقتصر الشروط الخاصة المرتبطة بالعروض الترويجية أو الباقات ("الشروط
            الخاصة") حصراً على مدتها المعينة صراحة، ولا تتجدد تلقائياً وتنتهي
            بانتهاؤه. وتكون -على سبيل المثال لا الحصر- أسعار العروض الترويجية أو
            الخصومات محصورة على فترتها المحددة وتنتهي بانتهاؤها. كما أن انطباق
            الشروط الخاصة متوقف على إتمام مدة الاشتراك كاملة.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">5. Minimum Operating Requirements</div>
          <div>
            The Client is responsible for ensuring that minimum requirements are
            met to operate the Rewaa platform, including suitable devices,
            adequate internet speed, and other relevant technical conditions.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٥. متطلبات التشغيل الدنيا</div>
          <div class="rtl">
            يلتزم العميل بالتحقق من توافر الحد الأدنى من المتطلبات اللازمة
            لتشغيل منصة رواء، بما في ذلك -على سبيل المثال لا الحصر- استخدام
            أجهزة رواء أو أجهزة ذات مواصفات فنية مناسبة، وتوفير سرعة إنترنت
            ملائمة، وغيره.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">6. Device Warranty</div>
          <div>
            Rewaa devices have a two-year warranty from invoice date covering
            manufacturing defects, excluding damages from misuse, negligence,
            accidents, or unauthorized modifications.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٦. ضمان الأجهزة</div>
          <div class="rtl">
            ضمان أجهزة رِواء سنتين تبدأ من تاريخ إصدار الفاتورة، ويشمل الضمان
            الخلل المصنعي، ولا يشمل الضمان الأعطال الناتجة عن سوء الاستخدام أو
            الإهمال أو الحوادث أو التعديلات غير المصرح بها.
          </div>
        </div>
      </div>
    </div>
    <!-- New Terms Points - End (Page 1) -->

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9"></div>
        <div class="col-3">
          <div class="text-right">
            @if (isNewTC) {
              Page {{ info.taxInvoicePages + 2 }} of
              {{ info.taxInvoicePages + 4 }} -
            } @else {
              Page {{ info.taxInvoicePages + 2 }} of
              {{ info.taxInvoicePages + 2 }} -
            }
            {{ getInvoiceId }}
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer - End -->
  </div>
  <!-- Terms & Conditions - End (Page 1) -->

  <!-- Terms & Conditions - Start (Page 2) -->
  <div
    class="print-wrapper page-break body"
    id="T&C-2"
    [ngClass]="{ 'pt-6 html2pdf__page-break': isBulkOperation }"
    *ngIf="!isCreditNote && isNewTC"
  >
    @if (
      !zatcaCompleted && invoice?.zatcaStatus !== zatcaStatusConstant.PreZatca
    ) {
      <div class="watermark">
        <div>DRAFT INVOICE</div>
        <div>فاتـــــــــــــــــــــورة مسودّة</div>
      </div>
    }
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        @if (this.invoice?.invoice_type === 'B2C') {
          <div class="fs-22 font-semibold">Simplified Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">
            فاتوره ضريبية مبسطه
          </div>
        } @else {
          <div class="fs-22 font-semibold">Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">فاتورة ضريبية</div>
        }
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>
    <!-- Header - End -->

    <!-- Page Title - Start -->
    <div class="grid pb-2 border-neutral-20 border-bottom-1 align-items-end">
      <div class="col-5">
        <div class="rw__fs-11 font-bold">
          Terms &amp; Conditions, and Privacy Policy
        </div>
        <div class="text-neutral-60">
          Scan QR to go through all of the terms &amp; conditions
        </div>
      </div>
      <div class="flex justify-content-center mx-auto">
        <img
          width="90"
          height="90"
          [src]="termsAndCondition.qrCode"
          alt="terms and condition qr code"
        />
      </div>
      <div class="col-5 text-right">
        <div class="rw__fs-11 font-bold">الشروط والأحكام وسياسة الخصوصية</div>
        <div class="text-neutral-60">
          قم بمسح الرمز للإطلاع على جميع الشروط والأحكام
        </div>
      </div>
    </div>
    <!-- Page Title - End -->

    <!-- New Terms Points - Page 2 - Start -->
    <div class="pt-2">
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">7. Refund Policy and Trial Period</div>
          <div>
            Refunds of any amounts paid that are eligible for refund are
            available within fourteen (14) calendar days of invoice issuance
            date ("Trial Period"). Refunds process within thirty (30) days of
            approval and require return of devices in original condition with
            all accessories and original packaging within the Trial Period. The
            Company may deduct a percentage or portion of the refundable amount
            proportionate to the condition. No refund requests will be accepted
            after the Trial Period. The Client's receipt of, or participation
            in, any government offer or support, including Monsha'at, shall be
            deemed a waiver of the trial right, and the right of return shall
            not apply to the Client under any circumstances.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٧. سياسة الإرجاع وفترة التجربة</div>
          <div class="rtl">
            تلتزم الشركة بإعادة أي مبالغ مدفوعة تنطبق عليها الإعادة خلال فترة
            التجربة المحددة بأربعة عشر (١٤) يوماً تقويمياً من تاريخ إصدار هذه
            الفاتورة ("فترة التجربة")، ويتم معالجة طلب الإرجاع ورد المبلغ خلال
            ثلاثين (٣٠) يوماً تقويمياً من تاريخ اعتماد الطلب، ولا يتم الاعتماد
            إلا بعد استلام الأجهزة بحالة سليمة وكاملة بجميع ملحقاتها الأصلية ومع
            التغليف الأصلي خلال فترة التجربة. وإذا لم يتحقق هذا الشرط جاز للشركة
            خصم نسبة أو جزء من المبلغ المستحق إرجاعه بما يتناسب مع الحالة. ولا
            يقبل أي طلب إرجاع بعد انتهاء فترة التجربة. ويعد استفادة العميل من أي
            عرض أو دعم حكومي ومنها منشآت تنازلاً منه عن حق التجربة ولا ينطبق
            عليه حق الإرجاع بأي حال من الأحوال.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">8. Refund With Device Retention</div>
          <div>
            If the Client requests a refund while keeping devices, the device
            value per Company pricing is deducted from the refund amount. For
            products under Special Terms, refunds terminate the contract with
            retroactive cancellation, requiring a new ordinary contract for the
            devices.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٨. الإرجاع مع الاحتفاظ بالأجهزة</div>
          <div class="rtl">
            إذا رغب العميل في طلب الإرجاع مع الاحتفاظ بالأجهزة المستلمة، تُخصم
            القيمة الأصلية للأجهزة وفقاً لسعرها لدى الشركة من إجمالي المبلغ
            المستحق إرجاعه للعميل. ويعد الإرجاع للمنتجات الخاضعة للشروط الخاصة
            فسخاً للعقد الذي تضمن هذه الشروط وإلغاء انطباقها بأثر رجعي، وعلى
            الطرفين إبرام عقد اعتيادي جديد يتعلق بالأجهزة.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">9. Technical Support Services</div>
          <div>
            The Company provides remote technical support around the clock, with
            some services being free and others paid according to the approved
            price list. Installation is self-performed by the Client with remote
            technical assistance available, and the Company is not obligated to
            conduct on-site visits.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">٩. خدمات الدعم الفني</div>
          <div class="rtl">
            تقدم الشركة الدعم الفني عن بُعد على مدار الساعة، وبعض الخدمات مجانية
            وأخرى مدفوعة وفقاً للقائمة الأسعار المعتمدة. التركيب ذاتي من قبل
            العميل مع إمكانية المساعدة الفنية عن بُعد، ولا تلتزم الشركة
            بالزيارات الميدانية.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">10. Training Sessions</div>
          <div>
            The Company provides, as needed, free scheduled remote group
            training sessions to its clients on platform usage, announced
            periodically. Clients may request individual remote training
            sessions, and the Company determines the estimated cost for
            individual training services.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١٠. جلسات التدريب</div>
          <div class="rtl">
            تقدم الشركة بحسب الحاجة جلسات تدريبية جماعية لعملائها على استخدام
            المنصة عن بُعد من خلال جلسات مجدولة ومجانية ويُعلن عنها بشكل دوري.
            ويحق للعميل طلب جلسات تدريب فردية عن بُعد، وتُحدد الشركة التكلفة
            التقديرية للخدمات التدريبية والفردية.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">11. RewaaPay Service</div>
          <div>
            If the Client subscribes to RewaaPay, activation and training are
            provided separately and remotely by a specialized team, following
            activation by the independent provider (third party) and provision
            of required devices, subject to estimated costs determined by the
            Company. RewaaPay is an independent service requiring separate
            cancellation procedures, and cancellation of the primary
            subscription does not automatically cancel RewaaPay services.
            Clients must handle RewaaPay cancellation directly with the payment
            service provider and may be subject to third-party cancellation
            penalties as determined by the payment processor.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١١. خدمة رواء باى</div>
          <div class="rtl">
            في حالة الاشتراك بخدمة المدفوعات رواء باى (RewaaPay)، يكون تفعيل
            الخدمة وتدريب العميل عليها بشكل مستقل وعن بعد وذلك بواسطة فريق
            متخصص، ويكون التدريب بعد تفعيل الخدمة من المزود المستقل (طرف ثالث)
            وتوفر الأجهزة المطلوبة وفقاً للتكلفة التقديرية التي تحددها الشركة.
            وتُعتبر خدمة رواء باى خدمة مستقلة تتطلب إجراءات إلغاء منفصلة. وإلغاء
            الاشتراك الرئيسي لا يؤدي تلقائياً إلى إلغاء خدمات رواء باى. ويجب على
            العملاء التعامل مع إلغاء رواء باى مباشرة مع مقدم خدمة الدفع وقد
            يكونون عرضة لغرامات إلغاء من طرف ثالث كما يحددها معالج المدفوعات.
          </div>
        </div>
      </div>
    </div>
    <!-- New Terms Points - End (Page 2) -->

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9"></div>
        <div class="col-3">
          <div class="text-right">
            Page {{ info.taxInvoicePages + 3 }} of
            {{ info.taxInvoicePages + 4 }} -
            {{ getInvoiceId }}
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer - End -->
  </div>
  <!-- Terms & Conditions - End (Page 2) -->

  <!-- Terms & Conditions - Start (Page 3) -->
  <div
    class="print-wrapper page-break body"
    id="T&C-3"
    [ngClass]="{ 'pt-6 html2pdf__page-break': isBulkOperation }"
    *ngIf="!isCreditNote && isNewTC"
  >
    @if (
      !zatcaCompleted && invoice?.zatcaStatus !== zatcaStatusConstant.PreZatca
    ) {
      <div class="watermark">
        <div>DRAFT INVOICE</div>
        <div>فاتـــــــــــــــــــــورة مسودّة</div>
      </div>
    }
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        @if (this.invoice?.invoice_type === 'B2C') {
          <div class="fs-22 font-semibold">Simplified Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">
            فاتوره ضريبية مبسطه
          </div>
        } @else {
          <div class="fs-22 font-semibold">Tax Invoice</div>
          <div class="rw__fs-7 font-normal text-neutral-60">فاتورة ضريبية</div>
        }
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>
    <!-- Header - End -->

    <!-- Page Title - Start -->
    <div class="grid pb-2 border-neutral-20 border-bottom-1 align-items-end">
      <div class="col-5">
        <div class="rw__fs-11 font-bold">
          Terms &amp; Conditions, and Privacy Policy
        </div>
        <div class="text-neutral-60">
          Scan QR to go through all of the terms &amp; conditions
        </div>
      </div>
      <div class="flex justify-content-center mx-auto">
        <img
          width="90"
          height="90"
          [src]="termsAndCondition.qrCode"
          alt="terms and condition qr code"
        />
      </div>
      <div class="col-5 text-right">
        <div class="rw__fs-11 font-bold">الشروط والأحكام وسياسة الخصوصية</div>
        <div class="text-neutral-60">
          قم بمسح الرمز للإطلاع على جميع الشروط والأحكام
        </div>
      </div>
    </div>
    <!-- Page Title - End -->

    <!-- New Terms Points - Page 3 - Start -->
    <div class="pt-2">
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">12. Rewaa Accounting Service</div>
          <div>
            The Accounting Service is an optional additional service
            supplementing the primary subscription, enabling the Client to
            upload invoices, documents, and financial data via the Rewaa
            platform using automation tools and the AI assistant, with the
            Company's accounting team reviewing and organizing such data to
            prepare preliminary accounting records, reports, and a draft tax
            return. It is an operational, internal-accounting service that does
            not replace a licensed accountant or certified external auditor, and
            does not include representation before the competent authorities or
            filing returns on the Client's behalf; the Client remains the
            principal taxpayer responsible for the accuracy of its data and
            returns. The service requires an active primary subscription
            throughout its term and that monthly operations not exceed the
            prescribed limit. The service carries fees separate from the primary
            subscription fees, as set out in the invoice in accordance with the
            Company's approved price list, and such fees accrue and renew in
            accordance with the payment provisions published within those terms.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١٢. خدمة المحاسبة من رواء</div>
          <div class="rtl">
            تُعد خدمة "المحاسبة" خدمة إضافية اختيارية مكمّلة للاشتراك الأساسي،
            تتيح للعميل رفع فواتيره ومستنداته وبياناته المالية عبر منصة رواء
            باستخدام أدوات الأتمتة والمساعد الذكي، ليتولّى فريق المحاسبة لدى
            الشركة مراجعتها وتنظيمها لأغراض إعداد سجلات وتقارير محاسبية أولية
            ومسودة الإقرار الضريبي. وهي خدمة ذات طبيعة تشغيلية داخلية لا تُغني
            عن المحاسب القانوني أو المراجع الخارجي المعتمد، ولا تشمل التمثيل
            أمام الجهات المختصة أو تقديم الإقرارات نيابة عن العميل الذي يبقى
            المكلّف الأصيل المسؤول عن صحة بياناته وإقراراته. ويُشترط للحصول على
            الخدمة وجود اشتراك أساسي فعّال طوال مدتها وألا يتجاوز عدد العمليات
            الشهرية الحد المقرّر. تُحتسب للخدمة رسوم مستقلة عن رسوم الاشتراك
            الأساسي تُبيّن في الفاتورة وفق قائمة الأسعار المعتمدة لدى الشركة،
            وتُستحق وتتجدد وفقاً لأحكام السداد المنشورة ضمن تلك الشروط.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">13. Third-Party Services and Terms</div>
          <div>
            Certain services, devices, or subscriptions obtained through the
            Company may be subject to the terms and conditions of third parties.
            In such cases, those terms apply as relevant and form part of this
            Agreement. The Company shall have sole discretion to determine their
            applicability and scope, and the Client's compliance with such terms
            is a prerequisite for access to the related services.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١٣. خدمات وشروط الأطراف الثالثة</div>
          <div class="rtl">
            قد تخضع بعض الخدمات أو الأجهزة أو الاشتراكات التي تحصل عليها من خلال
            الشركة للشروط وأحكام أطراف أخرى ("طرف ثالث"). وفي هذه الحالة تسري
            تلك الشروط والأحكام الإضافية بالقدر الذي يكون فيه ذات صلة، وتُعد
            جزءاً مكملاً لهذه الاتفاقية. يكون للشركة السلطة التقديرية في تحديد
            نطاق سريانها وتطبيقها. ويُعد التزام العميل بتلك الشروط الإضافية
            شرطاً لازماً للاستفادة من تلك الخدمات.
          </div>
        </div>
      </div>
      <div class="terms-row">
        <div class="tg-col">
          <div class="font-bold mb-1">14. Complete Agreement</div>
          <div>
            The prevailing Terms and Conditions and policies published on the
            Company's official website and any amendments thereto constitute a
            binding and effective agreement between the parties, and represent
            the complete agreement between them, and supersede all prior
            agreements, whether oral or written, unless expressly agreed
            otherwise in writing by both parties. The provisions listed above
            are the most prominent provisions of the general terms published on
            the Company's website, which the Client is committed to in full.
          </div>
        </div>
        <div class="tg-col">
          <div class="font-bold mb-1">١٤. الاتفاقية الكاملة</div>
          <div class="rtl">
            تُعد الشروط والأحكام والسياسات السارية بالشركة والمنشورة على
            موقعها الرسمي وأي تعديل يتم عليها اتفاقية ملزمة وسارية بين الطرفين،
            وتمثل كامل الاتفاق بينهما، ولا يُعتد بأي اتفاقات شفهية أو مكتوبة
            سابقة، ما لم يتم الاتفاق صراحة وكتابة على خلاف ذلك من قبل الطرفين.
            وتعد البنود المذكورة أعلاه أبرز البنود للشروط العامة المنشورة على
            موقع الشركة والتي يلتزم بها العميل كاملة.
          </div>
        </div>
      </div>
    </div>
    <!-- New Terms Points - End (Page 3) -->

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9"></div>
        <div class="col-3">
          <div class="text-right">
            Page {{ info.taxInvoicePages + 4 }} of
            {{ info.taxInvoicePages + 4 }} -
            {{ getInvoiceId }}
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer - End -->
  </div>
  <!-- Terms & Conditions - End (Page 3) -->

  <!-- <div class="py-6"></div> -->

  <div
    id="credit-page"
    [ngClass]="{ 'pt-3': isBulkOperation }"
  ></div>

  <!-- Credit Page - Start -->
  <div class="hide">
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        <div class="fs-22 font-semibold">Credit Note</div>
        <div class="rw__fs-7 font-normal text-neutral-60">إشعار دائن</div>
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>

    <!-- Invoice & Buyer Info - Start -->
    <div class="grid">
      <div class="col-3">
        <div class="font-medium">Bill to</div>
        <div class="font-medium text-neutral-60 mb-1">العميل</div>
        <div>مؤسسة عبدالرحمن هلال للمقاولات والترقيع شركة شخص واحد</div>
        <div>
          3575 Al Feidh, Irqah Unit 123456789011 No Kingdom of Saudi Arabia
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column gap-2">
          <div>
            <div class="font-medium">Buyer Tax Number</div>
            <div class="font-medium text-neutral-60 mb-1">
              رقم السجل الضريبي للعميل
            </div>
            <div>264867547786453</div>
          </div>
          <div>
            <div class="font-medium">Buyer ID: CR</div>
            <div class="font-medium text-neutral-60 mb-1">
              معرّف العميل: سجل تجاري
            </div>
            <div>1234567890</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column gap-2">
          <div>
            <div class="font-medium">Credit Note Number</div>
            <div class="font-medium text-neutral-60 mb-1">رقم إشعار دائن</div>
            <div>CN-000101</div>
          </div>
          <div>
            <div class="font-medium">Credit Note Issue Date</div>
            <div class="font-medium text-neutral-60 mb-1">
              تاريخ إصدار إشعار دائن
            </div>
            <div>23 Dec 2024, 07:35:59 AM</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column gap-2 text-right">
          <div>
            <div class="font-medium">Invoice Number</div>
            <div class="font-medium text-neutral-60 mb-1">رقم الفاتورة</div>
            <div>INV-000100</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Highlight - Start -->
    <div class="text-right pt-2 border-top-1 border-neutral-20">
      <div class="font-medium">Total Credit Note Amount</div>
      <div class="font-medium text-neutral-60">إجمالي قيمة إشعار الدائن</div>
      <div class="flex gap-1 align-items-center justify-content-end">
        <div class="line-height-1">
          <div class="rw__fs-9">SAR</div>
          <div class="rw__fs-11 text-neutral-60">ر.س</div>
        </div>
        <div class="rw__fs-5">2300.00</div>
      </div>
    </div>

    <!-- Invoice Item Line Table - Start-->
    <div class="pb-2 pt-3">
      <table class="print-table print-border-table print-item-table">
        <thead>
          <tr>
            <th class="text-left">
              <div class="font-medium text-neutral-60">#</div>
            </th>
            <th>
              <div class="font-medium">Item / Description</div>
              <div class="font-medium text-neutral-60">الوصف / المنتج</div>
            </th>
            <th>
              <div class="font-medium">Price</div>
              <div class="font-medium text-neutral-60">سعر الوحدة</div>
            </th>
            <th>
              <div class="font-medium">Quantity</div>
              <div class="font-medium text-neutral-60">الكمية</div>
            </th>
            <th>
              <div class="font-medium">Discount</div>
              <div class="font-medium text-neutral-60">خصم</div>
            </th>
            <th>
              <div class="font-medium">Taxable Amount</div>
              <div class="font-medium text-neutral-60">
                المبلغ الخاضع للضريبة
              </div>
            </th>
            <th>
              <div class="font-medium">VAT</div>
              <div class="font-medium text-neutral-60">القيمة المضافة</div>
            </th>
            <th>
              <div class="font-medium">Amount</div>
              <div class="font-medium text-neutral-60">المجموع</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">
              <div class="font-medium text-neutral-60">1</div>
            </td>
            <td class="text-neutral-60">
              <div class="font-semibold">
                <div>Basic Plan (1 year)</div>
                <div>اشتراك باقة أساسية (سنة)</div>
              </div>
              <div>1 Jan 2023-31 Dec 2024</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>x3</div>
            </td>
            <td>
              <div>-4000</div>
              <div class="text-neutral-60">60%</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>300</div>
              <div class="text-neutral-60">15%</div>
            </td>
            <td>
              <div>2300</div>
            </td>
          </tr>
          <tr>
            <td class="text-left">
              <div class="font-medium text-neutral-60">1</div>
            </td>
            <td class="text-neutral-60">
              <div class="font-semibold">
                <div>Basic Plan (1 year)</div>
                <div>اشتراك باقة أساسية (سنة)</div>
              </div>
              <div>1 Jan 2023-31 Dec 2024</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>x3</div>
            </td>
            <td>
              <div>-4000</div>
              <div class="text-neutral-60">60%</div>
            </td>
            <td>
              <div>2000</div>
            </td>
            <td>
              <div>300</div>
              <div class="text-neutral-60">15%</div>
            </td>
            <td>
              <div>2300</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Notes & Calculation Summary - Start -->
    <div class="grid">
      <div class="col-6">
        <div class="font-medium">Notes</div>
        <div class="font-medium text-neutral-60 mb-1">ملاحظات</div>
        <div>-</div>
      </div>
      <div class="col-6">
        <table class="print-table print-item-table">
          <tbody>
            <tr>
              <td>
                <div class="font-medium">Subtotal</div>
                <div class="font-medium text-neutral-60">
                  الإجمالي غير شامل الضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>6000</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total Discount</div>
                <div class="font-medium text-neutral-60">إجمالي الخصم</div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>-4000</div>
                <div class="text-neutral-60">60%</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total Taxable Amount</div>
                <div class="font-medium text-neutral-60">
                  إجمالي المبلغ الخاضع للضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>2000</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total VAT</div>
                <div class="font-medium text-neutral-60">
                  إجمالي ضريبة القيمة المضافة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>300</div>
                <div class="text-neutral-60">15%</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total</div>
                <div class="font-medium text-neutral-60">
                  الإجمالي شامل الضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div class="font-medium">2300</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9">
          <img
            src="/assets/images/invoice-pdf-qr.svg"
            alt=""
          />
          <div class="mt-2">
            This QR code is encoded as per ZATCA's invoicing requirements
          </div>
          <div>
            رمز الإستجابة السريعة مشفّر بحسب متطلبات هيئة الزكاة والضريبة
            والجمارك للفوترة الإلكترونية
          </div>
        </div>
        <div class="col-3">
          <div class="text-right">Page 1 of 1 - CN-000101</div>
        </div>
      </div>
    </footer>
  </div>

  <!-- Credit Page - End -->

  <!-- <div class="py-6"></div> -->

  <div id="payment-summary-page"></div>

  <!-- Payment Page - Start -->
  <div class="hide">
    <!-- Header - Start -->
    <header class="grid pb-3">
      <div class="col-5">
        <div class="fs-22 font-semibold">Payment Summary</div>
        <div class="rw__fs-7 font-normal text-neutral-60">ملخّص المدفوعات</div>
      </div>
      <div class="col-2">
        <ng-container *ngTemplateOutlet="rewaaLogo"></ng-container>
      </div>
      <div
        class="col-5 text-neutral-60 text-right"
        [innerHTML]="rewaaInfo"
      ></div>
    </header>
    <!-- Header - End -->

    <!-- Invoice & Buyer Info - Start -->
    <div class="grid">
      <div class="col-3">
        <div class="font-medium">Customer</div>
        <div class="font-medium text-neutral-60 mb-1">العميل</div>
        <div>مؤسسة عبدالرحمن هلال للمقاولات والترقيع شركة شخص واحد</div>
        <div>
          3575 Al Feidh, Irqah Unit 123456789011 No Kingdom of Saudi Arabia
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column gap-2">
          <div>
            <div class="font-medium">Buyer Tax Number</div>
            <div class="font-medium text-neutral-60 mb-1">
              رقم السجل الضريبي للعميل
            </div>
            <div>264867547786453</div>
          </div>
          <div>
            <div class="font-medium">Buyer ID: CR</div>
            <div class="font-medium text-neutral-60 mb-1">
              معرّف العميل: سجل تجاري
            </div>
            <div>1234567890</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="flex flex-column gap-2">
          <div>
            <div class="font-medium">Invoice Number</div>
            <div class="font-medium text-neutral-60 mb-1">رقم الفاتورة</div>
            <div>INV-000100</div>
          </div>
        </div>
      </div>
      <div class="col-3 text-right">
        <div class="flex flex-column gap-2">
          <div>
            <div class="font-medium">Last Updated</div>
            <div class="font-medium text-neutral-60 mb-1">تاريخ آخر تحديث</div>
            <div>23 Dec 2024, 07:35:59 AM</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Invoice & Buyer Info - End -->

    <!-- Invoice Item Line Table - Start-->
    <div class="pb-2 pt-6">
      <table class="print-table print-border-table payment-table">
        <thead>
          <tr>
            <th class="text-left">
              <div class="font-medium">Transaction Date</div>
              <div class="font-medium text-neutral-60">تاريخ العملية</div>
            </th>
            <th class="text-left">
              <div class="font-medium">Payment Method</div>
              <div class="font-medium text-neutral-60">طريقة الدفع</div>
            </th>
            <th class="text-left">
              <div class="font-medium">Reference No.</div>
              <div class="font-medium text-neutral-60">الرقم المرجعي</div>
            </th>
            <th>
              <div class="font-medium">Amount Paid</div>
              <div class="font-medium text-neutral-60">المبلغ المدفوع</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">
              <div class="font-semibold text-neutral-60">23 Dec 2024</div>
            </td>
            <td class="text-left">
              <div>Bank Transfer</div>
              <div class="text-neutral-60">Al Rajhi Bank</div>
            </td>
            <td class="text-left">
              <div>txn_169xRMUPwwaVhEB1U</div>
            </td>
            <td>
              <div class="font-semibold">800</div>
            </td>
          </tr>
          <tr>
            <td class="text-left">
              <div class="font-semibold text-neutral-60">23 Dec 2024</div>
            </td>
            <td class="text-left">
              <div>Credit Card</div>
              <div class="text-neutral-60">Visa</div>
            </td>
            <td class="text-left">
              <div>txn_169xRMUPwwaVhEB1U</div>
            </td>
            <td>
              <div class="font-semibold">800</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Invoice Item Line Table - End-->

    <!-- Notes & Calculation Summary - Start -->
    <div class="grid">
      <div class="col-6">
        <div class="font-medium">Notes</div>
        <div class="font-medium text-neutral-60 mb-1">ملاحظات</div>
        <div>-</div>
      </div>
      <div class="col-6">
        <table class="print-table print-item-table">
          <tbody>
            <tr>
              <td>
                <div class="font-medium">Invoice Total</div>
                <div class="font-medium text-neutral-60">
                  إجمالي الفاتورة شامل الضريبة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>2300</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Total Collected Amount</div>
                <div class="font-medium text-neutral-60">
                  إجمالي المبالغ المحصّلة
                </div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div>-2000</div>
              </td>
            </tr>
            <tr class="fs-7 text-neutral-60">
              <td class="pt-0">
                <div>Total Amount Paid</div>
                <div class="font-medium">إجمالي المبالغ المدفوعة</div>
              </td>
              <td class="pt-0">
                <div>SAR</div>
                <div>ر.س</div>
              </td>
              <td class="pt-0">
                <div>1800</div>
              </td>
            </tr>
            <tr class="fs-7 text-neutral-60">
              <td class="pt-0">
                <div>Customer Credit</div>
                <div>رصيد العميل</div>
              </td>
              <td class="pt-0">
                <div>SAR</div>
                <div>ر.س</div>
              </td>
              <td class="pt-0">
                <div>200</div>
              </td>
            </tr>
            <tr class="border-top-1 border-neutral-20">
              <td>
                <div class="font-medium">Total Due</div>
                <div class="font-medium text-neutral-60">إجمالي المستحق</div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div class="font-semibold">300</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="font-medium">Excess Balance</div>
                <div class="font-medium text-neutral-60">رصيد زائد</div>
              </td>
              <td>
                <div>SAR</div>
                <div class="font-medium text-neutral-60">ر.س</div>
              </td>
              <td>
                <div class="font-medium">0</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Notes & Calculation Summary - End -->

    @if (invoice?.dueAmount === 0) {
      <!-- Highlight Paid - Start -->
      <div class="flex gap-4 pt-2 justify-content-between">
        <div>
          <div class="font-medium">Payment Status</div>
          <div class="font-medium text-neutral-60">حالة الدفع</div>
          <div class="text-green-60 rw__fs-9 py-2">
            Paid In Full مدفوعة بالكامل
          </div>
        </div>
        <div class="text-right">
          <div class="font-medium">Total Due</div>
          <div class="font-medium text-neutral-60">إجمالي المستحق</div>
          <div class="flex gap-1 align-items-center justify-content-end">
            <div class="line-height-1">
              <div class="rw__fs-9">SAR</div>
              <div class="rw__fs-11 text-neutral-60">ر.س</div>
            </div>
            <div class="rw__fs-5">00</div>
          </div>
        </div>
      </div>
      <!-- Highlight Paid - End -->
    } @else {
      <!-- Highlight Unpaid - Start -->
      <div class="flex gap-4 pt-2 justify-content-between">
        <div>
          <div class="font-medium">Payment Status</div>
          <div class="font-medium text-neutral-60">حالة الدفع</div>
          <div class="text-red-60 rw__fs-9 py-2">
            Partially Paid مدفوع جزئياً
          </div>
        </div>
        <div class="text-right">
          <div class="font-medium">Total Due</div>
          <div class="font-medium text-neutral-60">إجمالي المستحق</div>
          <div
            class="flex gap-1 align-items-center justify-content-end text-red-60"
          >
            <div class="line-height-1">
              <div class="rw__fs-9">SAR</div>
              <div class="rw__fs-11">ر.س</div>
            </div>
            <div class="rw__fs-5">{{ invoice?.dueAmount }}</div>
          </div>
        </div>
      </div>
      <!-- Highlight Unpaid - End -->
    }

    <!-- Footer - Start -->
    <footer class="text-neutral-60 pt-3">
      <div class="grid align-items-end">
        <div class="col-9">
          <img
            src="/assets/images/invoice-pdf-qr.svg"
            alt=""
          />
          <div class="mt-2">
            This QR code is encoded as per ZATCA's invoicing requirements
          </div>
          <div>
            رمز الإستجابة السريعة مشفّر بحسب متطلبات هيئة الزكاة والضريبة
            والجمارك للفوترة الإلكترونية
          </div>
        </div>
        <div class="col-3">
          <div class="text-right">Page 1 of 1 - PS-000100</div>
        </div>
      </div>
    </footer>
    <!-- Footer - End -->
  </div>
</div>

<!-- Payment Page - End -->
